import React from 'react';

const LShape = () => (
    <svg width="7" height="18" viewBox="0 0 7 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '5px' }}>
        <path id="Vector 23" d="M1 3.05176e-05V17H7" stroke="#8B7355" />
    </svg>
);

export default LShape;
